package org.hs_soft.runmynesto.pages.login.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.derivedStateOf
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.percent

@Composable
fun ResetPassword(
    info: String,
    loading: Boolean,
    onCancelClick:()->Unit,
    onUpdatePasswordClick: (code: String, password: String)->Unit,
)
{
    val verificationCode = remember { mutableStateOf("") }
    val newPassword = remember { mutableStateOf("") }
    val confirmedNewPassword = remember { mutableStateOf("") }
    val showNewPassword = remember { mutableStateOf(false) }
    val showConfirmPassword = remember { mutableStateOf(false) }
    

    val hasMinLength = remember { derivedStateOf { newPassword.value.length >= Constants.minPassLen } }
    val hasLowerCase = remember { derivedStateOf { newPassword.value.any { it.isLowerCase() } } }
    val hasUpperCase = remember { derivedStateOf { newPassword.value.any { it.isUpperCase() } } }
    val hasNumber = remember { derivedStateOf { newPassword.value.any { it.isDigit() } } }
    val hasSpecialChar = remember { derivedStateOf { 
        newPassword.value.any { !it.isLetterOrDigit() } 
    } }

    val passwordsMatch = remember { derivedStateOf { 
        newPassword.value.isNotEmpty() && newPassword.value == confirmedNewPassword.value 
    } }
    
    val allRequirementsMet = remember { derivedStateOf {
        hasMinLength.value && 
        hasLowerCase.value && 
        hasUpperCase.value && 
        hasNumber.value && 
        hasSpecialChar.value &&
        passwordsMatch.value &&
        verificationCode.value.length==Constants.RESET_PASSWORD_CODE_Length
    } }
    
    Column(
        modifier = Modifier
            .fillMaxHeight()
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ){
        SpanText(
            text = info,
            modifier = Modifier
                .margin(
                    top= Dimen.largePadding,
                    bottom = Dimen.extraLargePadding,
                )
                .color(Theme.TextSecondary.rgb)
                .textAlign(TextAlign.Center)
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.Normal)
                .fontSize(FontSizes.mediumFontSize)
                .lineHeight(100.percent)
        )


        CustomEditText(
            modifier = Modifier,
            label = Strings.current().verificationCode,
            value = verificationCode.value,
            isRequired = false,
            hint = "",
            onFocusIn = {},
            onFocusOut = {},
            onInputChange = { it, _ ->
                verificationCode.value = it
            },
        )

        CustomEditText(
            modifier = Modifier,
            label = Strings.current().newPassword,
            value = newPassword.value,
            inputType = if (showNewPassword.value) InputType.Text else InputType.Password,
            endIconPath = if (showNewPassword.value) Res.PathIcon.hideEye else Res.PathIcon.showEye,
            hint = Strings.current().enterNewPassword,
            isRequired = false,
            onFocusIn = {},
            onFocusOut = {},
            onEndIconClick = {
                showNewPassword.value = !showNewPassword.value
            },
            onInputChange = { it, _ ->
                newPassword.value = it
            },
        )

        CustomEditText(
            modifier = Modifier,
            label = Strings.current().confirmPassword,
            value = confirmedNewPassword.value,
            isRequired = false,
            inputType = if (showConfirmPassword.value) InputType.Text
                else InputType.Password,
            endIconPath = if (showConfirmPassword.value) Res.PathIcon.hideEye
                else Res.PathIcon.showEye,
            hint = Strings.current().enterNewPasswordAgain,
            onFocusIn = {},
            onFocusOut = {},
            onEndIconClick = {
                showConfirmPassword.value = !showConfirmPassword.value
            },
            onInputChange = { it, _ ->
                confirmedNewPassword.value = it
            },
        )

        Column(
            modifier = Modifier
                .fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {
            PasswordRequirementItem(
                text = Strings.current().passwordReqLength,
                isMet = hasMinLength.value
            )
            
            PasswordRequirementItem(
                text = Strings.current().passwordReqLower,
                isMet = hasLowerCase.value
            )
            
            PasswordRequirementItem(
                text = Strings.current().passwordReqUpper,
                isMet = hasUpperCase.value
            )
            
            PasswordRequirementItem(
                text = Strings.current().passwordReqNumber,
                isMet = hasNumber.value
            )
            
            PasswordRequirementItem(
                text = Strings.current().passwordReqSpecial,
                isMet = hasSpecialChar.value
            )
        }

        Spacer()

        LoginSubmitButton(
            tvTitle = Strings.current().cancel,
            buttonTitle = Strings.current().updatePassword,
            loading = loading,
            isClickable = allRequirementsMet.value,
            onButtonClick = {
                if (allRequirementsMet.value) {
                    onUpdatePasswordClick(verificationCode.value, newPassword.value)
                }
            },
            onTitleClick = {
                onCancelClick()
            }
        )
    }
}
